'use client'

import React from 'react'

type Props = {
    length: number
    width: number
    height: number
}

const WIDTH = 340
const HEIGHT = 220

export default function RectangularPrismChart({ length, width, height }: Props) {
    const maxDim = Math.max(length, width, height, 0.0001)
    const scale = 140 / maxDim
    const w = Math.max(length * scale, 24)
    const h = Math.max(height * scale, 24)
    const depth = Math.max(width * scale, 18)
    const ox = depth * 0.55
    const oy = -depth * 0.4

    const fx = (WIDTH - w - ox) / 2
    const fy = (HEIGHT - h + oy) / 2 - 10

    const A = [fx, fy]
    const B = [fx + w, fy]
    const C = [fx + w, fy + h]
    const D = [fx, fy + h]
    const A2 = [fx + ox, fy + oy]
    const B2 = [fx + w + ox, fy + oy]
    const C2 = [fx + w + ox, fy + h + oy]

    const pts = (arr: number[][]) => arr.map((p) => p.join(',')).join(' ')

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <line x1={D[0]} y1={D[1]} x2={D[0] + ox} y2={D[1] + oy} stroke="#9ca3af" strokeWidth={1.5} strokeDasharray="4,3" />
            <line x1={A2[0]} y1={A2[1]} x2={D[0] + ox} y2={D[1] + oy} stroke="#9ca3af" strokeWidth={1.5} strokeDasharray="4,3" />
            <line x1={C2[0]} y1={C2[1]} x2={D[0] + ox} y2={D[1] + oy} stroke="#9ca3af" strokeWidth={1.5} strokeDasharray="4,3" />
            <polygon points={pts([A, B, B2, A2])} fill="#2563eb" opacity={0.12} stroke="#2563eb" strokeWidth={2} />
            <polygon points={pts([B, C, C2, B2])} fill="#2563eb" opacity={0.22} stroke="#2563eb" strokeWidth={2} />
            <polygon points={pts([A, B, C, D])} fill="#2563eb" opacity={0.32} stroke="#2563eb" strokeWidth={2} />

            <text x={(A[0] + B[0]) / 2} y={C[1] + 22} fontSize={11} textAnchor="middle" fill="#374151">l = {length.toFixed(2)}</text>
            <text x={A[0] - 8} y={(A[1] + D[1]) / 2} fontSize={11} textAnchor="end" fill="#374151">h = {height.toFixed(2)}</text>
            <text x={(B[0] + B2[0]) / 2 + 6} y={(B[1] + B2[1]) / 2 - 4} fontSize={11} textAnchor="start" fill="#374151">w = {width.toFixed(2)}</text>
        </svg>
    )
}
